export function flip_cards() {
  $('.flip-card').click(function(){
    $(this).toggleClass('flipped');
  });
}



// WEBPACK FOOTER //
// ./scripts/components/flipcards.js